export default __webpack_public_path__ + "static/18-29f9e90c6c3531040f70344877608e12.png";